export const getLabelKeyByValue = (labels, value: string): number => {
  const keys: string[] = Object.keys(labels);
  for (let i = 1; i < keys.length + 1; i += 1) {
    if (labels[i].toLowerCase() === value.toLowerCase()) {
      return i;
    }
  }
  return 1;
};
